import axios from "axios";

const GetCustomer = async (customer) => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_SHOPIFY_PROXY_URL}/api/graphql`,
      method: "POST",
      data: {
        query: `{
          customer(id: "gid://shopify/Customer/${customer}") {
            email
            metafield(namespace: "cart", key: "last_cart_id") {
              value
            }
          }
        }`,
      },
    });
    if (response.data.body.data.customer) {
      const { customer } = response.data.body.data;

      return {
        email: customer.email,
        lastCartId: customer?.metafield?.value ?? "",
      };
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default GetCustomer;
